export default "__VITE_ASSET__1a60a6a4__"